import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getContactActivity,
  getContactCrmActivity,
} from "../actions/contactAction";
import {
  AttendedStuentCount,
  getEventCrmDetails,
  getEventDetails,
  UniversityCount,
} from "../actions/eventAction";
import {
  getTodayComments,
  getTodayCrmUserComments,
  insertGuestCrmUser,
  insertGuestUser,
} from "../actions/userAction";
import Header from "../components/Header";
import OthersRecentComments from "../components/OthersRecentComments";
import SelfPastComments from "../components/SelfPastComments";
import SelfTodayComments from "../components/SelfTodayComments";
import Spinner, { ButtonSpinner } from "../components/Spinner";
import { GUEST_USER_COMMENT_INSERT_RESET } from "../constants/userConstants";
import { toastOptions, todayDate } from "../core/common";
import UniversityStudent from "../components/UniversityStudent";
import SEDLoading from "../components/SEDLoading";
import OpenPopup from "../components/Popup";
import Comment from "../components/Comment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AttendedStudent from "../components/AttendedStudent";
import AddUniversity from "../components/AddUniversity";
import { UniversityListRec } from "../actions/universityAction";
export default function Main(props) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [OpenNext, setOpenNext] = useState(false);
  const [DeleteAlert, setDeleteAlert] = useState({ msg: "", Delete: () => "" });
  const [OpenNext2, setOpenNext2] = useState(false);
  const [OpenNext3, setOpenNext3] = useState(false);
  const [OpenNext4, setOpenNext4] = useState(false);
  const [contactId, setContactId] = useState(0);
  const [ContactS, setContactS] = useState("");
  const [contactId2, setContactId2] = useState(0);
  const [comment, setComment] = useState("");
  const [LeadC, setLeadC] = useState("");
  const [errorValidator, setErrorValidator] = useState({
    error: "",
    success: "",
  });

  const eventName = useSelector((state) => state.eventName);
  const { loading, eventTitle, error } = eventName;
  const guestCrm = JSON.parse(localStorage.getItem("guestCrm"));
  const contactActivity = useSelector((state) => state.contactActivity);
  const {
    loading: contactLoading,
    error: contactError,
    activityRec,
  } = contactActivity;

  const guestUserInsert = useSelector((state) => state.guestUserInsert);

  const {
    loading: insertLoading,
    error: insertError,
    success: insertSuccess,
  } = guestUserInsert;

  const guestTodayComments = useSelector((state) => state.guestTodayComments);
  const { todayComments } = guestTodayComments;

  const guestUserLogin = useSelector((state) => state.guestUserLogin);
  const { userInfo } = guestUserLogin;

  const handleCheck = (e) => {
    const re = /^[0-9\b]+$/;
    // if (contactId && todayComments?.length == 0) {
    //   alert("Please add a comment before leave.");
    // } else {
    //   if (e.target.value === "" || re.test(e.target.value)) {
    //     setContactId(e.target.value);
    //   }
    // }

    if (e.target.value === "" || re.test(e.target.value)) {
      // setContactId(e.target.value);
      setContactS(e.target.value);
    }
  };

  const handleOpen = () => {};

  const handleSubmit = (e) => {
    e.preventDefault();
    if (activityRec && (todayComments?.length == 0 || !todayComments)) {
      // alert("Please add a comment before leave.");

      setDeleteAlert({
        msg: `Please Leave a comment Before leave this Contact - (${contactId2}) ?`,
        Delete: () => handleOpen(),
      });
      setOpenNext(true);
    } else {
      if (guestCrm) {
        dispatch(
          getContactCrmActivity({
            ContactId: ContactS,
          })
        );

        dispatch(
          getTodayCrmUserComments({
            Contact_Id: parseInt(ContactS),
            Event_Id: "0",
            User_Id: "0",
            TodayDate: todayDate,
            Guest_Id: "0",
            Past: false,
          })
        );
      } else {
        dispatch(
          getContactActivity({
            ContactId: ContactS,
          })
        );
        dispatch(
          getTodayComments({
            Contact_Id: parseInt(ContactS),
            Event_Id: "0",
            TodayDate: todayDate,
            Guest_Id: "0",
            Past: false,
          })
        );
      }

      setContactId(ContactS);
      setContactId2(ContactS);
    }
  };

  const handleCommentSubmit = (e, evl) => {
    e.preventDefault();
    if (!comment?.length || !comment) {
      toast.error("Please enter a comment before saving.", toastOptions);
    } else if (!LeadC && !evl) {
      toast.error(
        "Please select a student type before proceeding!",
        toastOptions
      );
    } else {
      if (guestCrm) {
        dispatch(
          insertGuestCrmUser({
            Contact_Id: parseInt(contactId),
            Event_Id: id,
            Comment: comment,
            Contact_Type: evl,
          })
        );

        dispatch(
          getTodayCrmUserComments({
            Contact_Id: parseInt(contactId),
            Event_Id: "0",
            User_Id: "0",
            TodayDate: todayDate,
            Guest_Id: "0",
            Past: false,
          })
        );
      } else {
        dispatch(
          insertGuestUser({
            Contact_Id: parseInt(contactId),
            Event_Id: id,
            Comment: comment,
            Contact_Type: evl,
          })
        );
        dispatch(
          getTodayComments({
            Contact_Id: parseInt(contactId),
            Event_Id: "0",
            TodayDate: todayDate,
            Guest_Id: "0",
            Past: false,
          })
        );
      }
    }
  };

  useEffect(() => {
    if (userInfo == undefined || userInfo == "" || userInfo == null) {
      if (guestCrm) {
        navigate(`/login`);
      } else {
        navigate(`/login`);
      }
    } else {
      if (eventTitle == undefined || eventTitle == "") {
        if (guestCrm) {
          dispatch(getEventCrmDetails(id));
        } else {
          dispatch(getEventDetails(id));
        }
      }
      if ((activityRec == undefined || activityRec == "") && contactId != 0) {
        if (guestCrm) {
          dispatch(
            getContactCrmActivity({
              ContactId: contactId,
            })
          );
        } else {
          dispatch(
            getContactActivity({
              ContactId: contactId,
            })
          );
        }
      }
      // if (insertSuccess != undefined || insertSuccess != "") {
      //   setComment("");
      //   setTimeout(() => {
      //     dispatch({
      //       type: GUEST_USER_COMMENT_INSERT_RESET,
      //     });
      //   }, 5000);
      // }
    }
  }, [dispatch, eventTitle, activityRec]);

  //   const [contactId2, setContactId2] = useState(0);

  //   const guestTodayComments = useSelector((state) => state.guestTodayComments);
  //   const { loading, error, todayComments } = guestTodayComments;

  //   useEffect(() => {
  //     // if (dataa == undefined || dataa.length == 0) {
  //     if (
  //       todayComments == undefined ||
  //       todayComments.length == 0 ||
  //       contactId2 !== props.contactId
  //     ) {
  //       dispatch(getTodayComments(props.commentJson));
  //       setContactId2(props.contactId);
  //     }
  //   }, [todayComments, props.contactId]);

  useEffect(() => {
    if (id == "undefined" || id == null || !id) {
      navigate("/");
    }
    dispatch(UniversityCount(id));
  }, [id]);

  useEffect(() => {
    if (insertSuccess) {
      toast.success(insertSuccess, toastOptions);
      setOpenNext2(false);
      setLeadC("");
      setComment("");
      if (id) {
        dispatch(AttendedStuentCount(id, guestCrm));
      }

      if (guestCrm) {
        dispatch(
          getTodayCrmUserComments({
            Contact_Id: parseInt(contactId),
            Event_Id: "0",
            User_Id: "0",
            TodayDate: todayDate,
            Guest_Id: "0",
            Past: false,
          })
        );
      } else {
        dispatch(
          getTodayComments({
            Contact_Id: parseInt(contactId),
            Event_Id: "0",
            TodayDate: todayDate,
            Guest_Id: "0",
            Past: false,
          })
        );
      }

      setTimeout(() => {
        dispatch({ type: GUEST_USER_COMMENT_INSERT_RESET });
      }, 4000);
    }

    if (insertError) {
      toast.error(insertError, toastOptions);
    }
  }, [insertError, insertSuccess]);

  return (
    <>
      {contactLoading || insertLoading ? <SEDLoading /> : ""}
      <Header>
        <div style={{ height: "76vh" }} className="student-information-body">
          <div className="row">
            <div class="col-md-12 text-center event-title">
              {!loading ? (
                <>
                  <div class="page-title">
                    <h2>{eventTitle}</h2>
                    <div class="title-underline"></div>
                  </div>
                  {/* <h3 style={{ color: "#6F42C1" }}>{eventTitle}</h3> */}
                </>
              ) : (
                <Spinner />
              )}
            </div>
            {/* <div className="col-md-2">
              <button
                className="btn get-call btn-sm shadow-none mb-2"
                type="button"
                onClick={(e) => setOpenNext2(true)}
              >
                Guest Activity
              </button>
            </div> */}
            <div className="col-md-8 student-info-tabel   Left_Student_Det_right">
              <div className="row  mb-3">
                <div className="col-md-9">
                  <h4 style={{ margin: "0", padding: "0" }}>
                    STUDENT INFORMATION
                  </h4>
                </div>
                <div className="col-md-3">
                  <form onSubmit={handleSubmit}>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Student Id. "
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        value={ContactS}
                        onChange={(e) => handleCheck(e)}
                      />
                      <div className="input-group-prepend">
                        <button className="input-group-text" id="basic-addon1">
                          <i
                            className="fa fa-search"
                            aria-hidden="true"
                            onClick={handleSubmit}
                          ></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <hr />
              <div className="Contact_Det_load"> 
              {contactLoading ? (
                <Spinner />
              ) : (
                <>
                  {activityRec ? (
                    <>
                      {activityRec != "" ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: guestCrm
                              ? activityRec?.replace(
                                  `style="display:none;margin-top:1.2px"`,
                                  `style="margin-top:1.2px"`
                                )
                              : activityRec?.replace(
                                  `style="margin-top:1.1px"`,
                                  `style="display:none;margin-top:1.1px"`
                                ),
                          }}
                        ></span>
                      ) : (
                        <>No Record Exist!</>
                      )}
                    </>
                  ) : (
                    <>
                      {contactError ? (
                        <>{contactError}</>
                      ) : (
                        <div>
                          Search the contact using the Contact Id textbox from
                          above.
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
              </div>
            </div>

            <div className="col-md-4 Left_Student_Det">
              <div className="leave-comments">
                <div className="custom-comments">
                  <div className="d-flex justify-content-center row">
                    <div className="col-md-12">
                      <UniversityStudent
                        CommentOpen={OpenNext3}
                        setCommentOpen={setOpenNext3}
                      />

                      <div class=" action-card">
                        {insertLoading ? (
                          <ButtonSpinner />
                        ) : (
                          <>
                            <button
                              class="action-btn action-btn-primary"
                              onClick={(e) => setOpenNext2(true)}
                            >
                              {/* <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path d="m3 11 18-5v12L3 14v-3z"></path>
                                <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"></path>
                              </svg> */}
                              POST COMMENT
                            </button>
                            {guestCrm ? (
                              <button
                                class="action-btn action-btn-secondary"
                                onClick={(e) => setOpenNext4(true)}
                              >
                                {/* <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                >
                                  <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
                                  <line x1="4" x2="4" y1="22" y2="15"></line>
                                </svg> */}
                                Recommended University
                              </button>
                            ) : (
                              " "
                            )}
                          </>
                        )}
                      </div>
                      {/* <div className="mt-3 text-center">
                        {insertLoading ? (
                          <ButtonSpinner />
                        ) : (
                          <>
                            <button
                              className="btn get-call btn-sm shadow-none mb-2"
                              type="button"
                              onClick={(e) => setOpenNext2(true)}
                            >
                              Post comment
                            </button>

                            {guestCrm ? (
                              <button
                                className="btn btn-outline-dark btn-sm ml-1 shadow-none mb-2"
                                type="button"
                                onClick={(e) => setOpenNext4(true)}
                              >
                                Recommended University
                              </button>
                            ) : (
                              ""
                            )}

                            <br />
                          </>
                        )}
                        <span className="text-sed-success">
                          {insertSuccess}
                        </span>
                      </div> */}
                      {/* <div className="d-flex flex-column comment-section">
                        <div className="bg-light p-3 mt-2">
                          <div className="d-flex flex-row align-items-start">
                            <img
                              className="rounded-circle"
                              src="/assets/img/Deafult-user.png"
                              alt=""
                              width="40"
                            />
                            <textarea
                              className="form-control ml-1 shadow-none textarea"
                              rows="6"
                              placeholder="Write your comment..."
                              value={comment}
                              onChange={(e) => setComment(e.target.value)}
                            ></textarea>
                          </div>
                          <div className="mt-3 text-right">
                            {insertLoading ? (
                              <ButtonSpinner />
                            ) : (
                              <>
                                <button
                                  className="btn get-call btn-sm shadow-none mb-2"
                                  type="button"
                                  onClick={(e) => handleCommentSubmit(e)}
                                >
                                  Post comment
                                </button>

                                <button
                                  className="btn btn-outline-dark btn-sm ml-1 shadow-none mb-2"
                                  type="button"
                                  onClick={(e) => setComment("")}
                                >
                                  Clear
                                </button>

                                <br />
                              </>
                            )}
                            <span className="text-sed-success">
                              {insertSuccess}
                            </span>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>

                  <div className="commentAccordion" id="accordionComment">
                    <div className="card">
                      <div
                        className="card-header"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                      >
                        <span className="title">Today </span>
                        <span className="accicon">
                          <i className="fas fa-angle-down rotate-icon"></i>
                        </span>
                      </div>
                      <div
                        id="collapseOne"
                        className="collapse show"
                        data-parent="#accordionComment"
                      >
                        <SelfTodayComments
                          contactId={contactId2}
                          todayComments={todayComments}
                          commentJson={{
                            Contact_Id: contactId2,
                            Event_Id: "0",
                            User_Id: "0",
                            TodayDate: todayDate,
                            Guest_Id: "0",
                            Past: false,
                          }}
                        />
                        {/* <div className="card-body">
                                                <div className="comment-content bg-white p-2">
                                                    <div className="d-flex flex-row user-info">
                                                        <img className="rounded-circle" src="assets/img/Deafult-user.png" alt="" width="40" />
                                                        <div className="d-flex flex-column justify-content-start ml-2"><span className="d-block font-weight-bold name">Marry Andrews</span><span className="date text-black-50">Lorem ipsum dolor - May 2022</span></div>
                                                    </div>
                                                    <div className="mt-2">
                                                        <p className="comment-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                                    </div>
                                                </div>
                                            </div> */}
                      </div>
                    </div>
                    <div className="card">
                      <div
                        className="card-header collapsed"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <span className="title">Past Comments</span>
                        <span className="accicon">
                          <i className="fas fa-angle-down rotate-icon"></i>
                        </span>
                      </div>
                      <div
                        id="collapseTwo"
                        className="collapse"
                        data-parent="#accordionComment"
                      >
                        <SelfPastComments
                          contactId={contactId2}
                          commentJson={{
                            Contact_Id: parseInt(contactId2),
                            Event_Id: "0",
                            User_Id: "0",
                            TodayDate: todayDate,
                            Guest_Id: "0",
                            Past: true,
                          }}
                        />
                      </div>
                    </div>
                    <div className="card">
                      <div
                        className="card-header collapsed"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                      >
                        <span className="title">Recent Activity</span>
                        <span className="accicon">
                          <i className="fas fa-angle-down rotate-icon"></i>
                        </span>
                      </div>
                      <div
                        id="collapseThree"
                        className="collapse"
                        data-parent="#accordionComment"
                      >
                        <OthersRecentComments
                          contactId={contactId2}
                          commentJson={{
                            Contact_Id: parseInt(contactId2),
                            User_Id: "1",
                            Event_Id: "0",
                            TodayDate: todayDate,
                            Guest_Id: "1",
                            Past: false,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Header>
      <OpenPopup
        OpenNext={OpenNext}
        setOpenNext={setOpenNext}
        DeleteData={DeleteAlert}
      />
      <Comment
        OpenNext={OpenNext2}
        setOpenNext={setOpenNext2}
        setComment={setComment}
        comment={comment}
        LeadC={LeadC}
        setLeadC={setLeadC}
        handleCommentSubmit={handleCommentSubmit}
      />
      <AddUniversity
        OpenNext={OpenNext4}
        ContactId={contactId}
        setOpenNext={setOpenNext4}
      />
      <AttendedStudent OpenNext={OpenNext3} setOpenNext={setOpenNext3} />
      <ToastContainer />
    </>
  );
}
